import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *投票
 * @param params
 * 
*/

export const vote = params => Http.post(`${baseUrl}/activity/vote`, params )

/**
 *投票信息
 * @param activityId 
 * 
*/

export const voteInfo = activityId => Http.get(`${baseUrl}/activity/vote/${activityId}/info` )

/**
 *投票成员列表
 * @param params
 * 
*/

export const voteList = params => Http.get(`${baseUrl}/activity/vote`, { params } )
